import { Directive, ElementRef, Input, OnInit } from '@angular/core';


@Directive({
  selector: '[formatDescription]'
})
export class AboutResultDirective implements OnInit {

  @Input('formatDescription') description?: string | null;

  constructor(
    private element: ElementRef<HTMLDivElement>
  ) { }

  ngOnInit(): void {
    if (!this.description) {
      return;
    }
    
    this.element.nativeElement.innerHTML = this.description.replace(/<p><\/p>/g, '').replace(/<br>/g, '') || '';
  }

}
